module.exports = __webpack_public_path__ + "img/banner02.482b024a.jpg";